/**
 * Safe localStorage utilities with error handling
 */

const ACTIVE_PROJECT_KEY = "__active_project";

export const getActiveProject = (): any => {
  try {
    const data = localStorage.getItem(ACTIVE_PROJECT_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Failed to parse active project from localStorage:", error);
    return {};
  }
};

export const getSurveysFromStorage = (): any[] => {
  try {
    const activeProject = getActiveProject();
    return activeProject?.surveys || [];
  } catch (error) {
    console.error("Failed to get surveys from localStorage:", error);
    return [];
  }
};

